import React, { useEffect, useMemo, useState } from "react";
import {
  AppleFilled,
  FacebookFilled,
  PlayStoreFilled,
  ViberFilled,
  YoutubeFilled,
  TelegramFilled,
  Cancel,
  StarLineIcon,
  ApkFilled,
} from "@assets";
import { useSelector } from "react-redux";
import {
  Button,
  CloseContainer,
  Container,
  Description,
  DescriptionContainer,
  ErrorContainer,
  ErrorDescription,
  ErrorImage,
  ErrorTitle,
  FollowTitle,
  FollowWrapper,
  Name,
  // RecaptchaContainer,
  RootContainer,
  TypeInfo,
  UserName,
  Welcome,
  Loader,
  SocialWrapper,
  Logo,
  DownloadWrapper,
} from "./ShareRegister.style";
import { t } from "i18next";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { Alert } from "@components";
import { SHARE_ID_LK } from "@constants";
import { api } from "@api";
import { getFingerprintData, formatShareName } from "@utils";
// import ReCAPTCHA from 'react-google-recaptcha';
import { Flex, Spin } from "antd";

const Link = ({ url, children, ...props }) => (
  <a href={url} target="_blank" rel="noreferrer noopen" {...props}>
    {children}
  </a>
);

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const ShareRegister = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { social_links } = useSelector((state) => state.app.settings);
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [promotext, setPromoText] = useState("");
  const [errorUI, setErrorUI] = useState(false);
  const [loading, setLoading] = useState(true);
  const [captchaToken, setCaptchaToken] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [shareType, setShareType] = useState('');
  const [flag, setFlag] = useState(false);

  const share_id = query.get(SHARE_ID_LK);

  useEffect(() => {
    if (!isLoggedIn && captchaToken) {
      getFingerprintData()
        .then(device_id => {
          viewShareLink(device_id);
        })
        .catch(() => { });
    }

    //eslint-disable-next-line
  }, [isLoggedIn, captchaToken]);

  useEffect(() => {
    let ele = document.getElementsByClassName('grecaptcha-badge')[0]?.style;
    if (ele) {
      ele.visibility = 'visible';
    }

    return () => {
      if (ele) {
        ele.visibility = 'hidden';
      }
    };
  }, []);

  // useEffect(() => {
  //   flag && handleRecaptchaVerification();

  // }, [flag]);

  useEffect(() => {
    setTimeout(() => {
      setFlag(true);
    }, 500);

  }, []);

  // const handleRecaptchaVerification = async () => {
  //   const token = await window.grecaptcha.execute(`${process.env.REACT_APP_RECAPTCHA_KEY}`);
  //   setCaptchaToken(token)
  // };

  const viewShareLink = (device_id) => {
    setLoading(true);
    api
      .viewShareLink({
        share_id,
        device_id,
        recaptcha_token: "pAAAKvTqUg6b6g-TZQFB9nLlxf",
      })
      .then(({ promoted_text, name, phone, type }) => {
        setLoading(false);
        setPromoText(promoted_text);
        setName(name);
        setPhone(phone);
        setShareType(type);
      })
      .catch((error) => {
        console.log(error)
        setLoading(false);
        setErrorUI(true)
      });
  };

  const goToRegister = () => {
    navigate(`/${PUBLIC_ROUTE.REGISTER}`);
  };

  const close = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const callHandler = (url) => {
    if (window.flutter_inappwebview?.callHandler) {
      window.flutter_inappwebview.callHandler("onEvent", url);
    }
  }

  if (isLoggedIn) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />
  }

  return (
    <>
      <RootContainer>

        {loading && (
          <Loader>
            <Spin />
          </Loader>
        )}

        {!loading && (
          <>
            <CloseContainer>
              <Cancel onClick={close} />
            </CloseContainer>
            <Logo />
            <Welcome>
              <Name>{t("common.appName")}</Name>
              <span> {t("share.welcome")} </span>
            </Welcome>
            <StarLineIcon style={{ width: 'calc(100% - 32px)' }} />

            {errorUI ? (
              <ErrorContainer>
                <ErrorImage />
                <ErrorTitle> {t("share.error")} </ErrorTitle>
                <ErrorDescription>
                  {t("share.viewErrorMsg")}
                </ErrorDescription>
                <StarLineIcon />
              </ErrorContainer>
            ) : (
              <Container>
                <DescriptionContainer>
                  <Description>

                    {promotext.split(t("common.appName"))[0]}

                    {promotext.split(t("common.appName"))[1] && (
                      <>
                        <span>{` ${t("common.appName")} `}</span>
                        {promotext.split(t("common.appName"))[1]}
                      </>
                    )}
                    {name && shareType &&
                      <>
                        <UserName>
                          {t("share.fromOwner", {
                            name,
                            phone,
                          })}
                        </UserName>
                        <TypeInfo>{`${t("common.appName")} ${formatShareName(shareType)}!`}</TypeInfo>
                      </>
                    }

                  </Description>
                </DescriptionContainer>
                <Button
                  type="secondary"
                  onClick={goToRegister}
                >
                  {t("share.register")}
                </Button>
              </Container>
            )}

            <FollowTitle style={{ paddingTop: '16px' }}>
              {t("home.appDownloadSubTitle2", { appName: t("common.appName") })}
            </FollowTitle>
            <DownloadWrapper>
              <Flex
                justify="center"
                gap={16}
                style={{ width: '100%' }}
              >
                <Link url={social_links?.app_store_link}>
                  <AppleFilled />
                </Link>
                <Link url={social_links?.play_store_link} onClick={() => callHandler(social_links?.play_store_link)}>
                  <PlayStoreFilled />
                </Link>
              </Flex>
              <Flex style={{ width: '100%' }}>
                <Link url={social_links?.download_link} onClick={() => callHandler(social_links?.download_link)}>
                  <ApkFilled />
                </Link>
              </Flex>
            </DownloadWrapper>

            <SocialWrapper>
              <FollowTitle>{t("home.appDownloadSubTitle1")}</FollowTitle>
              <FollowWrapper style={{ width: "60%" }}>
                <Link url={social_links?.fb_link}>
                  <FacebookFilled />
                </Link>
                <Link url={social_links?.viber_link}>
                  <ViberFilled />
                </Link>
                <Link url={social_links?.telegram_link}>
                  <TelegramFilled />
                </Link>
                <Link url={social_links?.youtube_link}>
                  <YoutubeFilled />
                </Link>
              </FollowWrapper>
            </SocialWrapper>
          </>
        )}
      </RootContainer>
      <Alert />
    </>
  );
};

export default ShareRegister;